import Vue from 'vue'

 
import 'animate.css'
import VueResource from 'vue-resource';

import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'
Vue.use(VueGlide)
 

 

//XLSX
import XLSX from "xlsx"

//
const Crypto = require('./crypto');

//
 
//to image
import * as htmlToImage from 'html-to-image';



 

// import axios from 'axios'; 
const axios = require("axios").default;
var qs = require('qs');

//number Mask
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
const currencyMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    includeThousandsSeparator: true,
    allowNegative: true,
});
const numberMask = createNumberMask({
    prefix: '',
    allowDecimal: false,
    includeThousandsSeparator: true,
    allowNegative: true,
});

Vue.mixin({
  data() {
    return { 
      XLSX:XLSX,
      axios:axios, 
      qs:qs,
      currencyMask:currencyMask,
      numberMask:numberMask,
      MBS: { 
        crypt:Crypto,
        toImage:htmlToImage, 
      }, 
    }
  },
})